"use strict";

var _overlay = require("./util/overlay");

var overlay = _interopRequireWildcard(_overlay);

var _tips = require("./util/tips");

var _wind = require("./util/wind");

var w = _interopRequireWildcard(_wind);

var _typhoonDom = require("./typhoonDom");

var _newsTip = require("./util/newsTip");

var _viewer = require("./business/viewer");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var progressType = "";

var bounds = [[27, 108.5], [19.2, 119]];
var date = new Date().Format("yyyy/MM/dd HH:00:00");

var endOfCloud = "&top=53.55&bottom=3.86&left=73.66&right=150&width=600&height=600";


var baseCloud = window.PAGE_CONFIG.BASE_URL + "/satelite/real/renderGrid?datetime=datetimes&satelite=FY2G&element=ir1&colorName=ir1_fy2g";
var getTime = window.PAGE_CONFIG.BASE_URL + "/satelite/real/findHeader_Latest?satelite=FY2G&element=ir1";
var urlCloud = {
  InfraRed: "" + baseCloud + endOfCloud };
var cloudBounds = [[53.54, 93.9], [3.75, 163.9]];

var cloudLoad = 0;
$(".rdList").on("click", function (e) {
  var _this = this;

  e.stopPropagation();
  $(this).removeClass("on");
  if ($(".rdList span").find("img").attr("src") == "./assets/typhoon_cloud@3x.png") {
    $(".rdList span").find("img").attr("src", "./assets/typhoon_cloud_pre@3x.png");
    $(this).addClass("newon");
    $(".nav_new").addClass("newon");
  } else {
    $(".rdList span").find("img").attr("src", "./assets/typhoon_cloud@3x.png");
    $(this).removeClass("newon");
    $(".nav_new").removeClass("newon");
  }

  if (!$(this).hasClass("newon")) {
    $(this).removeClass("newon");
    if (cloudLoad === 2) {
      (0, _newsTip.removeNewsTip)("InfraRed");
      overlay.removeOverlay("InfraRed");
      cloudLoad = 0;
    }
  } else {
    $(this).addClass("newon");
    if (cloudLoad !== 0) {
      return;
    }
    cloudLoad = 1;
    $.ajax({
      url: getTime
    }).then(function (data) {
      var time = data[0].datetime;
      var url = urlCloud["InfraRed"].replace("datetimes", new Date(time).Format("yyyy-MM-dd HH:mm:ss"));

      var img = new Image();
      img.onload = function () {
        if ($(_this).hasClass("newon")) {
          overlay.addImageOverlay("InfraRed", url, cloudBounds);
          (0, _newsTip.addNewsTip)("InfraRed", new Date(time).Format("yyyy年MM月dd日 HH:mm") + "&nbsp;" + "红外云图");
          cloudLoad = 2;
        } else {
          cloudLoad = 0;
        }
      };
      img.onerror = function () {
        if ($(_this).hasClass("newon")) {
          (0, _tips.getNoDataTips)(".cloudNoData");
          cloudLoad = 2;
        } else {
          cloudLoad = 0;
        }
      };
      img.src = url;
    });
  }
});

var radarTimes = [];
var timeLag = [];
var radarLayer = null;
var dataMcrUrl = window.PAGE_CONFIG.BASE_URL + "/temporary/forecast/renderGrid?type=swan&element=cappi&level=3&top=27&bottom=19.2&left=108.5&right=119&width=600&height=600&datetime={datetime}";
var dataLatestMcrUrl = window.PAGE_CONFIG.BASE_URL + "/temporary/forecast/findHeader_Latest?model=swan&element=cappi&level=3.0";
var addRadarLayer = function addRadarLayer(url) {
  if (radarLayer) {
    radarLayer.setUrl(url);
  } else {
    radarLayer = L.imageOverlay(url, bounds, {
      zIndex: 300
    }).addTo(map);
  }
};
var removeRadarLayer = function removeRadarLayer() {
  if (radarLayer) {
    map.removeLayer(radarLayer);
    radarLayer = null;
  }
};
$(".tgReflex").click(function (e) {
  e.stopPropagation();
  if ($(this).hasClass("on")) {
    progressType = "";
    removeRadarLayer();
    $(".radar_colourCode").hide();
    $(".rainProgressbar").stop().animate({
      top: "-2.67rem"
    });
    if ($(".buttonPlay").hasClass("on")) $(".buttonPlay").click();
    initProgress();
    $(".tyCl_list").stop().animate({
      top: "0rem"
    });
    if (!$(".cloudPopup .wrapper>p").length) $(".cloudPopup").hide();
  } else {
    if (progressType === "rain") {
      $(".rainForecast").click();
    }

    if ($(".rainFallChart").hasClass("on")) {
      $(".rainFallChart").click();
    }
    progressType = "radar";
    var $self = $(this);
    $.ajax({
      url: dataLatestMcrUrl
    }).then(function (data) {
      if (!Array.isArray(data) || !data.length || !$self.hasClass("on")) {
        return;
      }
      console.log("雷达回波", data);
      var ms = data[0]["datetime"];
      for (var i = 0; i < 4; i++) {
        var time = ms - i * 6 * 60 * 1000;
        radarTimes.unshift(new Date(time).Format("yyyy-MM-dd HH:mm:00"));
        timeLag.unshift(new Date(time).Format("mm"));
      }

      var datetime = new Date(radarTimes[3].replace(/-/g, "/")).getTime();
      var date = new Date(datetime).Format("yyyy年MM月dd日 HH:mm:00");
      $(".rain").text("雷达回波");
      $(".rain_nowtime").text("\u5F53\u524D\u65F6\u95F4\uFF1A" + date);
      $(".gpOne").text(timeLag[0]);
      $(".gpTwo").text(timeLag[1]);
      $(".gpThree").text(timeLag[2]);
      $(".gpFour").text(timeLag[3]);


      var url = dataMcrUrl.replace("{datetime}", radarTimes[3]);
      var img = new Image();
      img.onload = function () {
        if ($self.hasClass("on")) {
          $(".rainProgressbar").stop().animate({
            top: "0rem"
          }).addClass("on");
          $(".tyCl_list").stop().animate({
            top: "2rem"
          });
          addRadarLayer(url);
        } else {
          removeRadarLayer();
        }

        $(".radar_colourCode").show();
        $(".cloudPopup").show();
      };
      img.onerror = function () {
        $(".radar_colourCode").hide();
        $(".rainProgressbar").stop().animate({
          top: "0rem"
        }).addClass("on");
        $(".tyCl_list").stop().animate({
          top: "2rem"
        });
        (0, _tips.getNoDataTips)(".cloudNoData");
      };
      img.src = url;
    });
  }

  $(this).toggleClass("on");
});

$(".rsFollow").click(function (e) {
  e.stopPropagation();
  if ($(this).hasClass("on")) {
    window.xxx && window.xxx.remove();
    map.off("moveend zoomend", updateMap);
  } else {
    getRsImg(0, $(this), function (flag) {
      if (!flag) {
        window.xxx && window.xxx.remove();
        map.off("moveend zoomend", updateMap);
      }
    });
  }
  $(this).toggleClass("on");
});

var rsIndex = 0;

var rsUrlTime = "";
var getRsUrlTime = function getRsUrlTime() {
  return new Promise(function (resolve, reject) {
    var url = window.PAGE_CONFIG.BASE_URL + "/swan_titan/real/findHeader_Latest";
    $.ajax({
      url: url
    }).then(function (res) {
      return resolve(res[0].datetime);
    });
  });
};
getRsUrlTime().then(function (res) {
  rsUrlTime = res;
});
var getRsUrl = function getRsUrl(i) {
  var ms = new Date(rsUrlTime);
  ms -= ms % 360000 + i * 360000;
  var date = new Date(ms).Format("yyyy-MM-dd HH:mm:00");


  var defaultBound = {
    left: 100,
    top: 33,
    bottom: 18,
    right: 130
  };

  var height = 600;
  var width = 600;
  var pixelBounds = null;

  var maxRight = map.getBounds().getNorthEast().lng;
  var maxLeft = map.getBounds().getSouthWest().lng;
  var maxTop = map.getBounds().getNorthEast().lat;
  var maxBottom = map.getBounds().getSouthWest().lat;

  var top = maxTop > defaultBound.top ? defaultBound.top : maxTop;
  var bottom = maxBottom < defaultBound.bottom ? defaultBound.bottom : maxBottom;
  var right = maxRight > defaultBound.right ? defaultBound.right : maxRight;
  var left = maxLeft < defaultBound.left ? defaultBound.left : maxLeft;

  pixelBounds = L.bounds(map.latLngToLayerPoint([top, left]), map.latLngToLayerPoint([bottom, right]));
  var leftBottom = pixelBounds.getBottomLeft();
  var rightTop = pixelBounds.getTopRight();
  width = rightTop.x - leftBottom.x;
  height = leftBottom.y - rightTop.y;
  var rsbounds = L.latLngBounds([[top, left], [bottom, right]]);

  var url = window.PAGE_CONFIG.BASE_URL + "/swan_titan/real/renderTitan?datetime=" + date + "&top=" + top + "&bottom=" + bottom + "&left=" + left + "&right=" + right + "&width=" + width.toFixed(0) + "&height=" + height.toFixed(0);
  return {
    url: url,
    bounds: rsbounds
  };
};

var getRsImg = function getRsImg(i, $btn, fn) {
  var ms = new Date(rsUrlTime);
  ms -= ms % 360000 + i * 360000;
  var date = new Date(ms).Format("yyyy-MM-dd HH:mm:00");
  var id = "rainStorm";
  var url = getRsUrl(i).url;
  console.log("getRsUrl", url);
  var img = new Image();
  fn = fn || $.noop();
  img.onload = function () {
    rsIndex = i;
    var rsbounds = getRsUrl(i).bounds;
    window.xxx && window.xxx.remove();
    window.xxx = L.imageOverlay(url, rsbounds, {
      zIndex: 300
    }).addTo(map);

    $btn.hasClass("on") ? fn(true) : fn(false);
    if ($btn.hasClass("on")) map.on("moveend zoomend", updateMap);
  };
  img.onerror = function () {
    ++i;
    if (i >= 3) {
      fn(false);
      (0, _tips.getNoDataTips)(".cloudNoData");
      return;
    }
    getRsImg(i, $btn, fn);
  };
  img.src = url;
};

var updateFlag = void 0;
var updateMap = function updateMap() {
  var flag = updateFlag = Math.random();
  var rsUrlInfo = getRsUrl(rsIndex);
  var url = rsUrlInfo.url;
  var rsbounds = rsUrlInfo.bounds;
  var id = "rainStorm";
  var img = new Image();
  img.onload = function () {
    if (flag !== updateFlag) return;
    window.xxx.remove();
    window.xxx = L.imageOverlay(url, rsbounds, {
      zIndex: 300
    }).addTo(map);
  };
  img.onerror = function () {
    if (flag !== updateFlag) return;
    window.xxx.remove();
  };
  img.src = url;
};

var isWindCompAlive = false;
var windMarker = [];
var getWindData = function getWindData() {
  var province = window.PAGE_CONFIG.province;
  var city = window.PAGE_CONFIG.city;
  if (province == '广东省') {
    province = '广东';
    if (city.endsWith('市')) {
      city = city.substring(0, city.length - 1);
    }
  }
  var siteUrl = window.PAGE_CONFIG.BASE_URL + "/station/real/find_Latest?element=wd2dd&element=wd2df&province=" + province + "&city=" + city + "&element=lat&element=lon";
  $.ajax({
    url: siteUrl
  }).then(function (data) {
    if (!isWindCompAlive) return;

    (0, _newsTip.removeNewsTip)("wind");
    if (windMarker.length !== 0) {
      overlay.removeOverlay("windVel");
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = windMarker[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var opt = _step.value;

          map.removeLayer(opt);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      windMarker = [];
    }

    if (data && data.length) {
      var dateList = data.map(function (item) {
        return item.datetime;
      });
      var maxDate = Math.max.apply(Math, _toConsumableArray(dateList));
      (0, _newsTip.addNewsTip)("wind", new Date(maxDate).Format("yyyy年MM月dd日 HH:mm") + "&nbsp;实时风况");
      var siteIcon = L.icon({
        iconUrl: "assets/station.png",
        iconSize: [5, 5],
        iconAnchor: [2.5, 2.5]
      });
      var options = {
        icon: siteIcon,
        zIndexOffset: 1000
      };

      var windcolorlist = [{ value: 0, r: 0, g: 0, b: 0, a: 192 }, { value: 6, r: 32, g: 137, b: 30, a: 192 }, { value: 7, r: 2, g: 0, b: 253, a: 192 }, { value: 8, r: 252, g: 35, b: 35, a: 192 }];
      for (var i = 0; i < data.length; i++) {
        var item = data[i];
        var center = [item.elements.lat, item.elements.lon];

        var haveWd2dd = false;
        var haveWd2df = false;
        if (item.elements.wd2dd && item.elements.wd2dd !== 9999 && item.elements.wd2dd !== 999) {
          haveWd2dd = true;
          var marker = L.angleMarker([item.elements.lat, item.elements.lon], {
            icon: new L.Icon({
              iconUrl: "assets/stationWind/wind" + w.getVelLevel(item.elements.wd2df) + "-" + w.getWindColor(windcolorlist, w.getVelLevel(item.elements.wd2df)) + ".png",
              iconSize: [16, 30],
              iconAnchor: [0, 30]
            }),
            iconAngle: item.elements.wd2dd,
            iconOrigin: "0% 100%"
          });
          windMarker.push(marker);
          marker.addTo(map);
        }
        if (item.elements.wd2df && item.elements.wd2df !== 9999 && item.elements.wd2df !== 999) {
          haveWd2df = true;
          var className = void 0;
          if (item.elements.wd2df < 90 || item.elements.wd2df > 270) className = "wind_veltop";else className = "wind_velbot";
          var opts = L.divIcon({
            html: "<div class=\"" + className + "\">" + (Math.floor(item.elements.wd2df * 10) / 10 + "m/s") + "</div>"
          });
          overlay.addMarker("windVel", [item.elements.lat, item.elements.lon], {
            icon: opts
          });
        }

        if (haveWd2dd && haveWd2df) {
          overlay.addMarker("sitePoint", center, {
            icon: siteIcon,
            zIndexOffset: 1000
          });
        }
      }
    }
  });
};

$(".actualWind").click(function (e) {
  e.stopPropagation();

  if ($(this).hasClass("on")) {
    isWindCompAlive = false;
    overlay.removeOverlay("sitePoint");
    overlay.removeOverlay("windVel");
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = windMarker[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var opt = _step2.value;

        map.removeLayer(opt);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    windMarker = [];
    (0, _newsTip.removeNewsTip)("wind");
  } else {
    isWindCompAlive = true;
    getWindData();
  }
  $(this).toggleClass("on");
});

var getImageStringUrl = window.PAGE_CONFIG.BASE_URL + "/dataunit/temporary/renderTemporaryData?datetime={date}&type=swan&element=qpf&time=60&level=3&top=27&bottom=19&left=108.5&right=119.0&width=600&height=600&cacheCtrl=" + Date.now();

var rainTimes = [];
var rainLayer = void 0;
var timeLag_rain = [];
var reqRainTime = "";

var getRainTime = function getRainTime() {
  return new Promise(function (resolve, reject) {
    var url = window.PAGE_CONFIG.BASE_URL + "/temporary/forecast/findHeader_Latest?model=swan&element=qpf&level=3.0";
    $.ajax({
      url: url
    }).then(function (res) {
      timeLag_rain = [];
      rainTimes = [];
      for (var i = 0; i < res.length; i++) {
        var element = res[i];
        reqRainTime = new Date(res[0].datetime).Format("yyyy-MM-dd HH:mm:ss");
        timeLag_rain.push(element.leadtime);
        var qpfTime = element.datetime + element.leadtime * 60 * 1000;
        rainTimes.push(new Date(qpfTime).Format("yyyy-MM-dd HH:mm:ss"));
      }

      resolve(res[0].datetime);
    });
  });
};

var getRainUrl = function getRainUrl(leadtime) {
  return window.PAGE_CONFIG.BASE_URL + "/temporary/forecast/renderGrid?type=swan&element=qpf&level=3&top=27&bottom=19.2&left=108.5&right=119&width=600&height=600&datetime=" + reqRainTime + "&leadtime=" + leadtime;
};

$(".rainForecast").click(function (e) {
  if ($(this).hasClass("on")) {
    progressType = "";
    $(this).removeClass("on");
    $(".rainProgressbar").stop().animate({
      top: "-2.67rem"
    });
    if ($(".buttonPlay").hasClass("on")) $(".buttonPlay").click();
    initProgress();
    $(".tyCl_list").stop().animate({
      top: "0rem"
    });
    removeRainLayer();
    $(".rain_colourCode").hide();
    if (!$(".cloudPopup .wrapper>p").length) $(".cloudPopup").hide();
  } else {
    if ($(".tgReflex").hasClass("on")) {
      $(".tgReflex").click();
    }

    if ($(".rainFallChart").hasClass("on")) {
      $(".rainFallChart").click();
    }
    progressType = "rain";
    $(this).addClass("on");
    $(".early_warn").stop().animate({
      bottom: "-4.8rem"
    });
    if (map.hasEventListeners("click", _typhoonDom.hidePreWarnPopup)) {
      map.removeEventListener("click", _typhoonDom.hidePreWarnPopup);
      map.removeEventListener("movestart", _typhoonDom.hidePreWarnPopup);
    }
    var leadtimeArr = [];
    getRainTime().then(function (res) {
      if (progressType !== "rain") {
        return;
      }
      console.log("getRainTime", rainTimes, timeLag_rain);

      var datetime = new Date(rainTimes[3].replace(/-/g, "/")).getTime();
      var date = new Date(datetime).Format("yyyy年MM月dd日 HH:mm:00");
      $(".rain").text("降水预测");
      $(".rain_nowtime").text("\u5F53\u524D\u65F6\u95F4\uFF1A" + date);
      $(".gpOne").text(timeLag_rain[0]);
      $(".gpTwo").text(timeLag_rain[1]);
      $(".gpThree").text(timeLag_rain[2]);
      $(".gpFour").text(timeLag_rain[3]);

      var url = getRainUrl(timeLag_rain[3]);
      console.log("url", url);
      var img = new Image();
      img.onload = function () {
        $(".rainProgressbar").stop().animate({
          top: "0rem"
        }).addClass("on");
        $(".tyCl_list").stop().animate({
          top: "2rem"
        });
        addRainLayer(url);

        $(".rain_colourCode").show();
        $(".cloudPopup").show();
      };
      img.onerror = function () {
        $(".rainProgressbar").stop().animate({
          top: "0rem"
        }).addClass("on");
        $(".tyCl_list").stop().animate({
          top: "0rem"
        });
        (0, _tips.getNoDataTips)(".cloudNoData");
      };
      img.src = url;
    }).catch(function (e) {
      (0, _tips.getNoDataTips)(".cloudNoData");
    });
  }
});

var initProgress = function initProgress() {
  num = 3;
  $(".rainProgressbar .progressBar").stop().css("width", "100%");
  $(".rainProgressbar .progressFrame .grayPoint.in").removeClass("in");
  $(".buttonPlay.on").removeClass("on");
};

$(".buttonPlay").click(function (e) {
  e.stopPropagation();
  if ($(this).hasClass("on")) {
    clearTimeout(timeout);
    timeout = null;
    $(this).removeClass("on");
  } else {
    intvEvent();
    $(this).addClass("on");
  }
});

var num = 3,
    timeout = void 0;
var intvEvent = function intvEvent() {
  var speed = 1000;
  ++num;
  if (num > 3) {
    num = 0;
    $(".rainProgressbar .progressBar").stop().css("width", "25%");
    $(".rainProgressbar .progressFrame .grayPoint.in").removeClass("in");
  }

  if (num > 0) $(".rainProgressbar .point").eq(num - 1).children(".grayPoint").addClass("in");
  $(".rainProgressbar .progressBar").stop().animate({
    width: 25 + num * 25 + "%"
  }, speed);
  $(".rainProgressbar .progressRing").stop().animate({
    left: 25 + num * 25 + "%"
  }, speed);

  var timeArr = progressType === "rain" ? rainTimes : radarTimes;
  var date = new Date(timeArr[num].replace(/-/g, "/")).getTime();


  date = new Date(date).Format("yyyy年MM月dd日 HH:mm:00");
  setTimeout(function () {
    $(".rain_nowtime").text("\u5F53\u524D\u65F6\u95F4\uFF1A" + date);
  }, 150);

  var type = progressType;
  var url = progressType === "rain" ? getRainUrl(timeLag_rain[num]) : dataMcrUrl.replace("{datetime}", timeArr[num]);
  console.log("rainTimes", url);
  var img = new Image();
  img.onload = function () {
    if (type === progressType && $(".buttonPlay").hasClass("on")) {
      progressType === "rain" ? addRainLayer(url) : addRadarLayer(url);
      timeout = setTimeout(intvEvent, speed);
    } else {
      progressType === "rain" ? removeRainLayer() : removeRadarLayer();
    }
  };
  img.onerror = function () {
    progressType === "rain" ? removeRainLayer() : removeRadarLayer();
    if (type === progressType && $(".buttonPlay").hasClass("on")) {
      timeout = setTimeout(intvEvent, speed);
    }
  };
  img.src = url;
};

$(".rainProgressbar .grayPoint").click(function () {
  if ($(".buttonPlay").hasClass("on")) return;
  var $this = $(this);

  $this.addClass("in");
  $this.next().addClass("in");
  var $parent = $this.parent();
  $parent.prevAll().children(".grayPoint").addClass("in");
  $parent.nextAll().children(".grayPoint").removeClass("in");

  var index = $this.parent().index();
  num = index - 1;
  $(".rainProgressbar .progressBar").css("width", 25 + num * 25 + "%");
  $(".rainProgressbar .progressRing").css("left", 25 + num * 25 + "%");

  var timeArr = progressType === "rain" ? rainTimes : radarTimes;
  var date = new Date(timeArr[num].replace(/-/g, "/")).getTime();

  date = new Date(date).Format("yyyy年MM月dd日 HH:mm:00");
  $(".rain_nowtime").text("\u5F53\u524D\u65F6\u95F4\uFF1A" + date);

  var url = progressType === "rain" ? getRainUrl(timeLag_rain[num]) : dataMcrUrl.replace("{datetime}", timeArr[num]);
  var img = new Image();
  img.onload = function () {
    progressType === "rain" ? addRainLayer(url) : addRadarLayer(url);
  };
  img.onerror = function () {
    progressType === "rain" ? removeRainLayer() : removeRadarLayer();
  };
  img.src = url;
});

var addRainLayer = function addRainLayer(url) {
  if (rainLayer) {
    rainLayer.setUrl(url);
  } else {
    rainLayer = L.imageOverlay(url, [[27, 108.5], [19.2, 119]], {
      zIndex: 300
    });
    rainLayer.addTo(map);
  }
};

var removeRainLayer = function removeRainLayer() {
  if (rainLayer) {
    map.removeLayer(rainLayer);
    rainLayer = null;
  }
};

$(".rainFallChart").click(function (e) {
  if ($(this).hasClass("on")) {
    removeRainFallChart();
    $(this).removeClass("on");
    $(".rainfall_colourCode").hide();
    $(".rainFallTimeSelector").stop().animate({
      top: "-1.1rem"
    }).removeClass("on");
    $(".tyCl_list").animate({
      top: "0rem"
    });
  } else {
    if ($(".rainForecast").hasClass("on")) {
      $(".rainForecast").click();
    }
    if ($(".tgReflex").hasClass("on")) {
      $(".tgReflex").click();
    }
    $(this).addClass("on");
    $(".rainfall_colourCode").show();
    $(".rainFallTimeSelector").stop().animate({
      top: "0rem"
    }).addClass("on");
    $(".tyCl_list").animate({
      top: "1rem"
    });
    if (!$(".cloudPopup .wrapper>p").length) $(".cloudPopup").hide();
    $(".hourItem").eq(0).removeClass("selHourItem");
    $(".hourItem").eq(0).click();
  }
});

var rainFallChart;

var addRainFallChart = function addRainFallChart(hour) {
  var getImage = function getImage(i) {
    var date = new Date(Date.now() - 30 * 60000 - i * 10 * 60000);
    var minutes = date.getMinutes();
    minutes = minutes - minutes % 10;
    date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), minutes);
    var url = window.PAGE_CONFIG.BASE_URL + "/weather/awsRain/AWS_China_Rain" + (hour < 10 ? "0" + hour : hour) + "H_" + date.Format("yyyyMMddHHmm") + "00.png";
    var img = new Image();
    img.onload = function () {
      var tipText = date.Format("yyyy年MM月dd日 HH:mm") + "&nbsp;" + hour + "\u5C0F\u65F6\u96E8\u91CF\u56FE";
      if (rainFallChart) {
        rainFallChart.setUrl(url);
        (0, _newsTip.updateNewsTip)("rainfall", tipText);
        return;
      }
      rainFallChart = L.imageOverlay(url, [[17.79, 72.76], [53.81, 135.64]], {
        opacity: 0.9,
        zIndex: 10000
      });
      rainFallChart.addTo(map);
      rainFallChart.bringToBack();
      (0, _newsTip.addNewsTip)("rainfall", tipText);
    };
    img.onerror = function () {
      if (i <= 3) {
        getImage(i + 1);
      } else {
        (0, _tips.getNoDataTips)(".cloudNoData");
      }
    };
    img.src = url;
  };
  getImage(0);
};

var removeRainFallChart = function removeRainFallChart() {
  if (rainFallChart) {
    map.removeLayer(rainFallChart);
    rainFallChart = null;
    (0, _newsTip.removeNewsTip)("rainfall");
  }
};

$(".hourItem").click(function () {
  if ($(this).hasClass("selHourItem")) {
    return;
  } else {
    $(this).siblings().removeClass("selHourItem");
    $(this).addClass("selHourItem");
    var hour = $(this).attr("value");
    console.log("hour", hour);
    addRainFallChart(parseInt(hour, 10));
  }
});

var satelliteLayer = void 0;
var satelliteBgLayer = void 0;
var layerOpts = {
  subdomains: [1, 2, 3],
  maxZoom: 17,
  minZoom: 3
};
var addSatelliteChart = function addSatelliteChart() {
  if (!satelliteLayer) {
    var getImage = function getImage(i) {
      var date = new Date(Date.now() - 30 * 60000 - i * 10 * 60000);
      var hour = date.getHours();
      var minutes = date.getMinutes();
      minutes = minutes - minutes % 10;
      date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), minutes);
      var wdTime = new Date(date).setHours(hour - 8);
      var url = window.PAGE_CONFIG.BASE_URL + "/weather/h8Pixlin/tile/" + new Date(wdTime).Format("yyyyMMdd/HH/mm") + "/p83/x6y2z3.jpg";
      var img = new Image();
      img.onload = function () {
        cloudLoad = true;
        if (!satelliteBgLayer) {
          satelliteBgLayer = new L.tileLayer(window.PAGE_CONFIG.BASE_URL + "/weather/tilemap/szmb/zoom{z}/x{x}y{y}z{z}.png", layerOpts);
        }
        satelliteBgLayer.addTo(map);

        if (satelliteLayer) {
          satelliteLayer.setUrl(url);
        } else {
          satelliteLayer = L.ymsatLayer(window.PAGE_CONFIG.BASE_URL + "/weather/h8Pixlin/tile/" + new Date(wdTime).Format("yyyyMMdd/HH/mm") + "/p83/x{x}y{y}z{z}.jpg", {
            opacity: 0.6
          }).addTo(map);
          (0, _newsTip.addNewsTip)("satelliteChart", "\u5317\u4EAC\u65F6:" + date.Format("yyyy/MM/dd/ HH:mm") + "&nbsp;\u536B\u661F\u56FE");
          (0, _viewer.viewerCor)();
        }
      };
      img.onerror = function () {
        if (i <= 3) {
          getImage(i + 1);
        } else {
          cloudLoad = true;
          (0, _tips.getNoDataTips)(".cloudNoData");
        }
      };
      img.src = url;
    };
    getImage(0);
  }
};

var removeSatelliteChart = function removeSatelliteChart() {
  if (satelliteLayer) {
    map.removeLayer(satelliteLayer);
    satelliteLayer = null;
  }
  if (satelliteBgLayer) {
    map.removeLayer(satelliteBgLayer);
    satelliteBgLayer = null;
  }
};


//////////////////
// WEBPACK FOOTER
// ./js/addOverlay.js
// module id = 34
// module chunks = 0